// Forked from https://code.amazon.com/packages/DigitalVideoUI/blobs/mainline/--/src/components/Button/Button.js

import * as React from "react"
import { SpecialButtonProps, Button, Translucent, Playback } from "@amzn/dvui/dist/Button";
import { extractClassNamesFromProps, omit } from './utils'
import { IconType } from '@amzn/dvui/dist/Icon'
import * as st from "./Button.module.scss"
import ProgressBar from "../../components/collection/FacetedCarousel/Card/ProgressBar";
import { camelToDataAttrs } from "DVWebNodeUtils";

export const WatchlistButton: React.ComponentType<SpecialButtonProps> = (props) => {
  const status = props.status
  const use =
    status === 'added'
      ? IconType.WATCHLIST_ON
      : status === 'progress'
        ? IconType.SPINNER
        : IconType.ADD

  return <Button {...props} useIcon={use} use={Translucent} />
}

const deeplinkDataBlackList = [
  'data-ref',
  'data-fallback-url',
  'data-resume-time',
  'data-title-id',
  'data-is-avod',
  'data-token',
  'data-pageTitle-id'
]

const DeeplinkingClass = 'js-deeplinkable'

const processDeeplinkData = (props: { [x: string]: any; deepLinkingData?: any; }) => {
  const {deepLinkingData = {}, ...otherProps} = props
  const dataAttrs = camelToDataAttrs(deepLinkingData)
  const filteredOtherProps = omit(otherProps, deeplinkDataBlackList)
  return {...filteredOtherProps, ...dataAttrs}
}

export const SquarePlayButton = ({ progress = 0, ...otherProps }) => {
  const processedProps = processDeeplinkData(otherProps)
  const playButtonClass = extractClassNamesFromProps(
    processedProps,
    st.squareButton,
    DeeplinkingClass
  )
    const progressObj = {percentage: progress}

  return (
    <Button
      {...processedProps}
      use={Playback}
      useIcon={IconType.PLAY_ARROW}
      className={playButtonClass}
    >
      <span>{processedProps.children}</span>
      <ProgressBar progress={progressObj} />
    </Button>
  )
}